// Generic Actions
export const SENDING_REQUEST =
	"crm-b2b-frontend/GenericCore/ActivityListing/SENDING_REQUEST";
export const REQUEST_ERROR =
	"crm-b2b-frontend/GenericCore/ActivityListing/REQUEST_ERROR";

// Specific actions for screens (Listing, Details etc) like Loading the screen contents and the table data

// Load Screen Content
export const LOAD_SCREEN =
	"crm-b2b-frontend/GenericCore/ActivityListing/LOAD_SCREEN";
export const LOAD_SCREEN_API = {
	type: "GET",
	url: "/api/v2/screen",
};
export const SCREEN_LOADED =
	"crm-b2b-frontend/GenericCore/ActivityListing/SCREEN_LOADED";

export const TABLE_VIEWS_LOADED =
	"crm-b2b-frontend/GenericCore/ActivityListing/TABLE_VIEWS_LOADED";

// Getting called directly without sagas
export const LOAD_FORM_API = {
	type: "GET",
	url: "/api/v2/form",
	requestParams: {
		screenId: "",
	},
};

export const LOAD_FILTERS_API = {
	type: "GET",
	url: "/api/v2/form-filters",
	requestParams: {
		screenId: "",
	},
};
export const FILTERS_LOADED =
	"crm-b2b-frontend/GenericCore/ActivityListing/FILTERS_LOADED";

// Delete Table View
export const DELETE_TABLE_VIEW =
	"crm-b2b-frontend/GenericCore/ActivityListing/DELETE_TABLE_VIEW";

// Load Transactions for the Table
export const LOAD_TRANSACTIONS =
	"crm-b2b-frontend/GenericCore/ActivityListing/LOAD_TRANSACTIONS";
export const LOAD_TRANSACTIONS_API = {
	type: "GET",
	url: "/api/v2/activities",
	bodyParams: {
		screenName: "",
		formId: "",
		moduleId: "",
		search: "",
		filter: [],
		sorted: [],
		pageSize: 25,
		page: 0,
	},
};

export const TRANSACTIONS_LOADED =
	"crm-b2b-frontend/GenericCore/ActivityListing/TRANSACTIONS_LOADED";
export const TRANSACTIONS_UPDATED =
	"crm-b2b-frontend/GenericCore/ActivityListing/TRANSACTIONS_UPDATED";
// Update Transactions in Bulk
export const BULK_UPDATE_TRANSACTIONS =
	"crm-b2b-frontend/GenericCore/ActivityListing/BULK_UPDATE_TRANSACTIONS";
export const BULK_UPDATE_TRANSACTIONS_API = {
	type: "PATCH",
	url: "/api/v2/activities",
	bodyParams: [],
};
export const BULK_UPDATE_TRANSACTIONS_COMPLETE =
	"crm-b2b-frontend/GenericCore/ActivityListing/BULK_UPDATE_TRANSACTIONS_COMPLETE";

export const CLEAR_TRANSACTIONS =
	"crm-b2b-frontend/GenericCore/ActivityListing/CLEAR_TRANSACTIONS";

export const CALENDAR_VIEW = "CALENDAR_VIEW";
export const LISTING_VIEW = "LISTING_VIEW";
export const KANBAN_VIEW = "KANBAN_VIEW";
export const LOAD_USERS =
	"crm-b2b-frontend/GenericCore/ActivityListing/LOAD_USERS";

export const LOAD_CALENDARS =
	"crm-b2b-frontend/GenericCore/ActivityListing/LOAD_CALENDARS";

export const LOAD_USERS_API = {
	type: "GET",
	url: "/api/v2/users/subordinates",
	bodyParams: {
		page: 0,
		pageSize: 100,
		search: "",
		sorted: [],
	},
};

export const LOAD_CALENDARS_API = {
	type: "GET",
	url: "/api/v2/calendars",
	bodyParams: {
		page: 0,
		pageSize: 100,
		search: "",
		sorted: [],
	},
};
export const USERS_LOADED =
	"crm-b2b-frontend/GenericCore/ActivityListing/USERS_LOADED";

export const CALENDARS_LOADED =
	"crm-b2b-frontend/GenericCore/ActivityListing/CALENDARS_LOADED";

// Select all record Ids
export const FETCH_RECORD_IDS =
	"crm-b2b-frontend/GenericCore/ActivityListing/FETCH_RECORD_IDS";
export const FETCH_RECORD_IDS_API = {
	type: "GET",
	url: "/api/v2/activities/record-ids",
	bodyParams: {
		screenName: "",
		moduleId: "",
		formId: "",
		search: "",
		filter: [],
	},
};
export const LOAD_RECORD_IDS =
	"crm-b2b-frontend/GenericCore/ActivityListing/LOAD_RECORD_IDS";
export const CLEAR_RECORD_IDS =
	"crm-b2b-frontend/GenericCore/ActivityListing/CLEAR_RECORD_IDS";

export const MARK_TASK_COMPLETED =
	"crm-b2b-frontend/GenericCore/ActivityListing/MARK_TASK_COMPLETED";
export const MARK_TASK_COMPLETED_API = {
	url: "/api/v2/activities/task/update-status",
	method: "PATCH",
	bodyParams: {
		records: { F31: "" },
	},
};

export const SCREEN_LOADING =
	"crm-b2b-frontend/GenericCore/ActivityListing/SCREEN_LOADING";
export const CREATE_OR_UPDATE_TABLE_VIEW =
	"crm-b2b-frontend/GenericCore/Listing/CREATE_OR_UPDATE_TABLE_VIEW";
export const TABLE_VIEWS_API = {
	url: "/api/v2/table-views",
};
export const KANBAN_VIEWS_API = {
	url: "/api/v2/kanban-views",
};
export const KANBAN_TRANSACTIONS_LOADED =
	"crm-b2b-frontend/GenericCore/ActivityListing/KANBAN_TRANSACTIONS_LOADED";
export const LOAD_MORE_TRANSACTIONS =
	"crm-b2b-frontend/GenericCore/ActivityListing/LOAD_MORE_TRANSACTIONS";
export const LOAD_ACTIVITIES_SCREEN_FILTERS =
	"crm-b2b-frontend/GenericCore/ActivityListing/LOAD_ACTIVITIES_SCREEN_FILTERS";
export const SET_LOADER =
	"crm-b2b-frontend/GenericCore/ActivityListing/SET_LOADER";

export const kabanScreen = {
	screenId: "TSCR4",
	screenName: "TASK",
	moduleId: "ACTM",
	status: "ACTIVE",
	transKey: "screen.task.kanban",
	iconName: "pc-task-module",
	type: "KANBAN",
	actionType: {
		core: [
			{
				formId: "TF1",
				transKey: "button.task.new",
				iconName: "add-symbol.svg",
				buttonType: "",
				order: 1,
				moduleId: "ACTM",
				action: "CREATE",
				status: "ACTIVE",
				tooltip: "tooltip.task.createNewTask",
			},
		],
		table: [
			{
				transKey: "button.table.search",
				iconName: "pc-search",
				buttonType: "SEARCH",
				order: 1,
				status: "ACTIVE",
				tooltip: "tooltip.generic.search",
			},
			{
				transKey: "button.table.refresh",
				iconName: "pc-refresh",
				buttonType: "REFRESH",
				order: 2,
				status: "ACTIVE",
				tooltip: "tooltip.generic.refresh",
			},
			{
				transKey: "button.table.filter",
				iconName: "pc-filter-list",
				buttonType: "FILTER",
				order: 3,
				status: "ACTIVE",
				tooltip: "tooltip.generic.filter",
			},
			{
				transKey: "button.table.view",
				iconName: "pc-preview",
				buttonType: "VIEW",
				order: 4,
				status: "ACTIVE",
				tooltip: "tooltip.generic.view",
			},
			{
				transKey: "button.table.tag",
				iconName: "pc-tag",
				buttonType: "TAGS",
				order: 5,
				status: "ACTIVE",
				tooltip: "tooltip.generic.tag",
			},
		],
		individual: [
			{
				formId: "TF2",
				iconName: "pc-edit",
				transKey: "button.task.edit",
				moduleId: "ACTM",
				action: "UPDATE",
				order: 1,
				status: "ACTIVE",
				tooltip: "tooltip.task.edit",
			},
			{
				formId: "TF3",
				iconName: "pc-bulk-edit-tags",
				transKey: "button.generic.tags",
				moduleId: "ACTM",
				action: "UPDATE",
				order: 2,
				status: "ACTIVE",
				tooltip: "tooltip.tag.edit",
			},
			{
				transKey: "button.delete",
				formId: "GF11",
				moduleId: "ACTM",
				action: "DELETE",
				iconName: "pc-delete",
				order: 3,
				status: "ACTIVE",
				tooltip: "tooltip.task.delete",
			},
		],
	},
};

export const taskTypeOptions = [
	{
		label: "Tasks",
		value: "ONLY_TASK",
		className: "",
	},
	{
		label: "Subtasks",
		value: "SUB_TASK",
		className: "",
	},
	{
		label: "Tasks and subtasks",
		value: "TASK_AND_SUB_TASK",
		className: "",
	},
];
